const ASSIGNEDDATE = 'startDate'
const DUEDATE = 'endDate'

module.exports = {
  ASSIGNEDDATE,
  DUEDATE,
}
